import { CoreStoreType, GameCommunicationMessageType, gameStateActions, IGameCommunicationProcessor } from '@pp/core';

import { MWGameStatus } from '../../../store/slices/mwState/types';

export class GameCommunicationRestoreDealingProcessor implements IGameCommunicationProcessor {
  messageName = 'mwDealing';

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    const isLoadedInActiveRound = store.getState().gameState.timer <= 0;
    const hasBets = store.getState().bets.betStack.length > 0;

    if (isLoadedInActiveRound && hasBets) {
      store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.SPINNING));
    } else {
      store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.WaitForNextGame));
    }
  }
}
